import { createSlice } from '@reduxjs/toolkit';
import { DobUtilityState } from './utility-types';
import { getDominio } from './utility-thunks';

const initialState: DobUtilityState = {
  getDominioStatus: 'idle',
  getDominioError: false,
  getDominioResponse: undefined,
};

const dobUtilitySlice = createSlice({
  name: 'features/dobUtility',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDominio.pending, (state) => {
      state.getDominioStatus = 'loading';
      state.getDominioError = false;
    });
    builder.addCase(getDominio.rejected, (state) => {
      state.getDominioStatus = 'failed';
      state.getDominioError = true;
    });
    builder.addCase(getDominio.fulfilled, (state, action) => {
      state.getDominioStatus = 'succeeded';
      state.getDominioError = false;
      state.getDominioResponse = action.payload;
    });
  },
});

export default dobUtilitySlice.reducer;
